import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { buildErrorMessage } from 'utils'
import { workflowKeys } from './workflowKeys'
import { IWorkflow, Reassignment } from 'stores/Workflows/Types'
import { SelectPropertyValue } from 'api/clients/PropertyClient'

interface Props {
  folderId: string
}

interface WorkflowUpdateJobRecord {
  id: string
  status: 'pending' | 'processing' | 'successful' | 'failed'
}

export interface UpdatePayload {
  property_id: number
  config: IWorkflow['configuration']
  property_values: SelectPropertyValue[]
  reassignments: Reassignment[]
}

export const useUpdateWorkflow = ({ folderId }: Props) => {
  return useMutation<{ workflow_update_job_record: WorkflowUpdateJobRecord }, Error, UpdatePayload>(
    workflowKeys.update(folderId),
    async (attributes) => {
      const response = await sendToApi(`/folders/${folderId}/workflow`, {
        method: 'PUT',
        body: attributes,
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }
      return response.data
    },
  )
}
